import { defineComponent as _defineComponent } from 'vue'
import { createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["disabled"]
const _hoisted_2 = ["disabled"]
const _hoisted_3 = ["disabled"]
const _hoisted_4 = ["disabled"]
const _hoisted_5 = ["disabled"]
const _hoisted_6 = ["disabled"]
const _hoisted_7 = ["disabled"]
const _hoisted_8 = ["disabled"]
const _hoisted_9 = ["disabled"]
const _hoisted_10 = ["disabled"]
const _hoisted_11 = ["disabled"]
const _hoisted_12 = ["disabled"]
const _hoisted_13 = ["disabled"]
const _hoisted_14 = ["disabled"]

import type { ViewPreset, ViewerTool } from 'Core/Components/Ifc/IfcViewerCore';

    /**
     * Viewer-operations toolbar shared by IfcImporter and IfcEditor: show-all /
     * fit / view presets / ghost / invert / length-area-clip measurements / clear.
     *
     * Page-specific actions (Import, Open File, Export, Annotate, Transform,
     * Close, etc.) stay on the consuming page — they're rendered before this
     * toolbar via the parent's <#toolbar> slot.
     */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'IfcViewerToolbar',
  props: {
    modelLoaded: { type: Boolean },
    hasSelection: { type: Boolean },
    ghostMode: { type: Boolean },
    activeTool: {}
  },
  emits: ["showAll", "fit", "setView", "resetRotation", "toggleGhost", "invertIsolation", "setTool", "clearMeasurements"],
  setup(__props: any) {

    

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createCommentVNode(" Use Fragments root so the buttons sit inline within the parent's toolbar. "),
    _createElementVNode("button", {
      class: "btn btn-default btn-sm ifc-toolbar-btn",
      disabled: !__props.modelLoaded,
      title: "Show all (A)",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('showAll')))
    }, [...(_cache[14] || (_cache[14] = [
      _createElementVNode("i", { class: "fa fa-eye" }, null, -1 /* CACHED */),
      _createTextVNode(" All ", -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_1),
    _createElementVNode("button", {
      class: "btn btn-default btn-sm ifc-toolbar-btn",
      disabled: !__props.modelLoaded,
      title: "Fit to selection (F)",
      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('fit')))
    }, [...(_cache[15] || (_cache[15] = [
      _createElementVNode("i", { class: "fa fa-crosshairs" }, null, -1 /* CACHED */),
      _createTextVNode(" Fit ", -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_2),
    _cache[24] || (_cache[24] = _createElementVNode("span", { class: "ifc-toolbar-sep" }, null, -1 /* CACHED */)),
    _createElementVNode("button", {
      class: "btn btn-default btn-sm ifc-toolbar-btn",
      disabled: !__props.modelLoaded,
      title: "Isometric view",
      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('setView', 'iso')))
    }, "Iso", 8 /* PROPS */, _hoisted_3),
    _createElementVNode("button", {
      class: "btn btn-default btn-sm ifc-toolbar-btn",
      disabled: !__props.modelLoaded,
      title: "Top view",
      onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('setView', 'top')))
    }, "Top", 8 /* PROPS */, _hoisted_4),
    _createElementVNode("button", {
      class: "btn btn-default btn-sm ifc-toolbar-btn",
      disabled: !__props.modelLoaded,
      title: "Front view",
      onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('setView', 'front')))
    }, "Front", 8 /* PROPS */, _hoisted_5),
    _createElementVNode("button", {
      class: "btn btn-default btn-sm ifc-toolbar-btn",
      disabled: !__props.modelLoaded,
      title: "Side view",
      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.$emit('setView', 'side')))
    }, "Side", 8 /* PROPS */, _hoisted_6),
    _createElementVNode("button", {
      class: "btn btn-default btn-sm ifc-toolbar-btn",
      disabled: !__props.modelLoaded,
      title: "Reset rotation",
      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.$emit('resetRotation')))
    }, [...(_cache[16] || (_cache[16] = [
      _createElementVNode("i", { class: "fa fa-refresh" }, null, -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_7),
    _cache[25] || (_cache[25] = _createElementVNode("span", { class: "ifc-toolbar-sep" }, null, -1 /* CACHED */)),
    _createElementVNode("button", {
      class: _normalizeClass(["btn btn-sm ifc-toolbar-btn", __props.ghostMode ? 'btn-info' : 'btn-default']),
      disabled: !__props.modelLoaded,
      title: "Ghost mode",
      onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$emit('toggleGhost')))
    }, [...(_cache[17] || (_cache[17] = [
      _createElementVNode("i", { class: "fa fa-adjust" }, null, -1 /* CACHED */),
      _createTextVNode(" Ghost ", -1 /* CACHED */)
    ]))], 10 /* CLASS, PROPS */, _hoisted_8),
    _createElementVNode("button", {
      class: "btn btn-default btn-sm ifc-toolbar-btn",
      disabled: !__props.modelLoaded || !__props.hasSelection,
      title: "Invert isolation (hide selected)",
      onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.$emit('invertIsolation')))
    }, [...(_cache[18] || (_cache[18] = [
      _createElementVNode("i", { class: "fa fa-eye-slash" }, null, -1 /* CACHED */),
      _createTextVNode(" Invert ", -1 /* CACHED */)
    ]))], 8 /* PROPS */, _hoisted_9),
    _cache[26] || (_cache[26] = _createElementVNode("span", { class: "ifc-toolbar-sep" }, null, -1 /* CACHED */)),
    _createElementVNode("button", {
      class: _normalizeClass(["btn btn-sm ifc-toolbar-btn", __props.activeTool === 'length' ? 'btn-warning' : 'btn-default']),
      disabled: !__props.modelLoaded,
      title: "Length measurement",
      onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.$emit('setTool', 'length')))
    }, [...(_cache[19] || (_cache[19] = [
      _createElementVNode("i", { class: "fa fa-arrows-h" }, null, -1 /* CACHED */)
    ]))], 10 /* CLASS, PROPS */, _hoisted_10),
    _createElementVNode("button", {
      class: _normalizeClass(["btn btn-sm ifc-toolbar-btn", __props.activeTool === 'angle' ? 'btn-warning' : 'btn-default']),
      disabled: !__props.modelLoaded,
      title: "Angle measurement",
      onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.$emit('setTool', 'angle')))
    }, [...(_cache[20] || (_cache[20] = [
      _createElementVNode("i", { class: "fa fa-drafting-compass" }, null, -1 /* CACHED */)
    ]))], 10 /* CLASS, PROPS */, _hoisted_11),
    _createElementVNode("button", {
      class: _normalizeClass(["btn btn-sm ifc-toolbar-btn", __props.activeTool === 'area' ? 'btn-warning' : 'btn-default']),
      disabled: !__props.modelLoaded,
      title: "Area measurement",
      onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.$emit('setTool', 'area')))
    }, [...(_cache[21] || (_cache[21] = [
      _createElementVNode("i", { class: "fa fa-square-o" }, null, -1 /* CACHED */)
    ]))], 10 /* CLASS, PROPS */, _hoisted_12),
    _createElementVNode("button", {
      class: _normalizeClass(["btn btn-sm ifc-toolbar-btn", __props.activeTool === 'clip' ? 'btn-warning' : 'btn-default']),
      disabled: !__props.modelLoaded,
      title: "Clipping plane (double-click to place)",
      onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.$emit('setTool', 'clip')))
    }, [...(_cache[22] || (_cache[22] = [
      _createElementVNode("i", { class: "fa fa-cut" }, null, -1 /* CACHED */)
    ]))], 10 /* CLASS, PROPS */, _hoisted_13),
    (__props.activeTool && __props.activeTool !== 'none')
      ? (_openBlock(), _createElementBlock("button", {
          key: 0,
          class: "btn btn-default btn-sm ifc-toolbar-btn",
          disabled: !__props.modelLoaded,
          title: "Clear measurements/clips",
          onClick: _cache[13] || (_cache[13] = ($event: any) => (_ctx.$emit('clearMeasurements')))
        }, [...(_cache[23] || (_cache[23] = [
          _createElementVNode("i", { class: "fa fa-trash" }, null, -1 /* CACHED */)
        ]))], 8 /* PROPS */, _hoisted_14))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})